export const groupedBySection = collection => {
  let groupedContent = collection.reduce((acc, it) => {
    (acc[it.section] = acc[it.section] || []).push(it);
    return acc;
  }, {});
  return groupedContent;
};

export const groupedByFilters = (collection, types, sections) => {
  let filter = collection;

  if (types.length > 0) {
    filter = collection.filter(item => {
      return types.indexOf(item.attachmentType) > -1;
    });
  }
  if (sections.length > 0) {
    filter = filter.filter(item => {
      return sections.indexOf(item.section) > -1;
    });
  }
  const filtered = filter.reduce((acc, it) => {
    (acc[it.section] = acc[it.section] || []).push(it);
    return acc;
  }, {});
  return filtered;
};

export const allSections = collection => {
  let sections = collection.reduce((acc, it) => {
    acc[it.section] = acc[it.section] || [];
    return acc;
  }, {});
  return sections;
};
